import { create } from "zustand";

interface User {
  id: string;
  name: string;
  email: string;
  image: string | null;
}

interface UserState {
  user: User | null;
  orgName: string | null;
  isManager: boolean;
  isSuperadmin: boolean;
  setUser: (user: User | null) => void;
  setOrgName: (orgName: string | null) => void;
  setIsManager: (isManager: boolean) => void;
  setIsSuperadmin: (isSuperadmin: boolean) => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  orgName: null,
  isManager: false,
  isSuperadmin: false,
  setUser: (user) => set({ user }),
  setOrgName: (orgName) => set({ orgName }),
  setIsManager: (isManager) => set({ isManager }),
  setIsSuperadmin: (isSuperadmin) => set({ isSuperadmin }),
}));
